import React from 'react'
import PropTypes from 'prop-types'

export default function ButtonArrow({ children, ...rest }) {
  return (
    <button
      className='flex-container flex-dir-row-reverse align-middle button button--small'
      {...rest}
    >
      <span>{children}</span>

      <span className='button__decor button__decor--small button__decor--reverse button__decor--reverse-right'>
        <svg
          width='96'
          height='96'
          viewBox='0 0 96 96'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle
            cx='52.421'
            cy='42.3158'
            r='40.5526'
            stroke='#BD9973'
          ></circle>
          <circle
            opacity='0.4'
            cx='58.1052'
            cy='48'
            r='34.8684'
            stroke='#838489'
          ></circle>
          <circle
            opacity='0.2'
            cx='48'
            cy='48'
            r='47.5'
            stroke='#B3B4B8'
          ></circle>
        </svg>
      </span>
    </button>
  )
}

ButtonArrow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}
